import(/* webpackMode: "eager" */ "/Users/adam.plocieniak/GIT/kick-video-downloader/app/(app)/channel/[slug]/error.tsx");
